import { render, staticRenderFns } from "./LearnBigData.vue?vue&type=template&id=3ba6a9f1&scoped=true"
import script from "./LearnBigData.vue?vue&type=script&setup=true&lang=js"
export * from "./LearnBigData.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LearnBigData.vue?vue&type=style&index=0&id=3ba6a9f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba6a9f1",
  null
  
)

export default component.exports